import { mapActions } from 'vuex';
import addFundsCard from '@/components/wallet/add-funds-card/add-funds-card.vue';
import addFundsBankTransfer from '@/components/wallet/add-funds-bank-transfer/add-funds-bank-transfer.vue';
import tabs from '@/components/generics/tabs/tabs.vue';
import accountVerifyMixin from '@/mixins/accountVerify';
import { TAB_INDEX_CREDIT, TAB_INDEX_ONLINE_BANKING } from '@/components/wallet/deposit/deposit';
import instantCreditService from '@/services/instant-credit';

export default {
  mixins: [
    accountVerifyMixin,
  ],
  components: {
    addFundsBankTransfer,
    addFundsCard,
    tabs,
  },
  props: {
    checkInstantCredit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTabs: false,
      hideTabs: false,
      activeTab: null,
      tabIndexOrder: [],
      isCreditCardAvailable: false,
      isOnlineBankingAvailable: false,
      instantCreditData: {},
    };
  },
  computed: {
    tabs() {
      const results = [];
      this.tabIndexOrder.forEach((v) => {
        if (this.isOnlineBankingAvailable && v === TAB_INDEX_ONLINE_BANKING) {
          results.push({
            name: TAB_INDEX_ONLINE_BANKING,
            title: 'Online Banking',
          });
        }
        if (this.isCreditCardAvailable && v === TAB_INDEX_CREDIT) {
          results.push({
            name: TAB_INDEX_CREDIT,
            title: 'Credit Card',
          });
        }
      });
      return results;
    },
    showCardTab() {
      return this.activeTab === TAB_INDEX_CREDIT;
    },
    showBankingTab() {
      return this.activeTab === TAB_INDEX_ONLINE_BANKING;
    },
  },
  methods: {
    ...mapActions('popup', ['setCurrentPopup']),
    ...mapActions('user', ['getStatus']),
    ...mapActions('wallet', ['getDepositMethods']),
    tabChange(name) {
      this.activeTab = name;
      // upon initial tab change if there is one tab hide options
      if (this.tabs.length === 1) {
        this.hideTabs = true;
      }
    },
    onBankTransferStep(step) {
      if (step === 3) {
        this.hideTabs = true;
      } else if (step === 1 || step === 2) {
        this.hideTabs = false;
      }
    },
  },
  created() {
    this.getDepositMethods().then((data) => {
      this.tabIndexOrder = data.tabIndexOrder;
      this.isCreditCardAvailable = data.isCreditCardAvailable;
      this.isOnlineBankingAvailable = data.isOnlineBankingAvailable;
      const shouldGoToWalletPage = !data.isCreditCardAvailable &&
        !data.isOnlineBankingAvailable &&
        this.isUserVerifiedFully;

      if (shouldGoToWalletPage) {
        if (this.$route.name === 'wallet') {
          this.setCurrentPopup();
        } else {
          this.$router.push({ name: 'wallet' });
        }
      } else if (this.checkInstantCredit) {
        instantCreditService.run()
          .then((instantCreditData) => {
            this.instantCreditData = instantCreditData;
            this.showTabs = true;

            if (this.instantCreditData.success) {
              this.getStatus();
            }
          });
      } else {
        this.showTabs = true;
      }
    });
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/add-funds-combined/add-funds-combined.js